import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import ReactPlayer from 'react-player';
import ViewImageAndText from '../../components/ViewImageAndText';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';

const InstituteDashboardSectionList = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    let instituteMasterId = localStorage.getItem("instituteMasterId")

    const [activeTab, setActiveTab] = useState("active");

    const [activeList, setActiveList] = useState([]);
    const [inActiveList, setInActiveList] = useState([]);

    const [startIndexActive, setStartIndexActive] = useState(null);
    const [startIndexInActive, setStartIndexInActive] = useState(null);

    const [currPageActive, setCurrPageActive] = useState(1);
    const [currPageInActive, setCurrPageInActive] = useState(1);

    const [itemsPerPageActive, setItemsPerPageActive] = useState(10);
    const [itemsPerPageInActive, setItemsPerPageInActive] = useState(10);

    const [displayedDataActive, setDisplayedDataActive] = useState([]);
    const [displayedDataInActive, setDisplayedDataInActive] = useState([]);

    const [totalPagesActive, setTotalPagesActive] = useState(0);
    const [totalPagesInActive, setTotalPagesInActive] = useState(0);



    const [activeSectionNameSort, setActiveSectionNameSort] = useState(null);
    const [activeSectionIdSort, setActiveSectionIdSort] = useState(null);
    const [activePrincipleNameSort, setActivePrincipleNameSort] = useState(null);

    const [inActiveSectionNameSort, setInActiveSectionNameSort] = useState(null);
    const [inActiveSectionIdSort, setInActiveSectionIdSort] = useState(null);
    const [inActivePrincipleNameSort, setInActivePrincipleNameSort] = useState(null);


    const [searchValueActive, setSearchValueActive] = useState(null);
    const [searchValueInActive, setSearchValueInActive] = useState(null);

    // const searchKeys = ["q_level", "q_type", "question", "option_a", "option_b", "option_c", "option_d", "ans"];
    const searchKeys = ["sectionName", "sectionId", "sectionInchargeName", "email", "contactNumber"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };


    useEffect(() => {
        getActiveSectionList();
        getInActiveSectionList();
    }, [])

    const getApiUrlActive = () => {
        return `/get-actived-section-list?instituteMasterId=${instituteMasterId}`;
    }

    const getApiUrlInActive = () => {
        return `/get-deactived-section-list?instituteMasterId=${instituteMasterId}`;
    }


    const getActiveSectionList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlActive();
            const response = await authorizedAxiosCommon.get(apiUrl);
            setActiveList(response.data.result);
        } catch (error) {
            setActiveList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getInActiveSectionList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlInActive();
            const response = await authorizedAxiosCommon.get(apiUrl);
            setInActiveList(response.data.result);
        } catch (error) {
            setInActiveList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        if (searchValueActive === '' && searchValueActive !== null) {
            setCurrPageActive(1);
            getActiveSectionList();
        }
    }, [searchValueActive]);

    useEffect(() => {
        if (searchValueInActive === '' && searchValueInActive !== null) {
            setCurrPageInActive(1);
            getInActiveSectionList();
        }
    }, [searchValueInActive]);



    const handleEmptySearchActive = (e) => {
        setSearchValueActive(e.target.value);
    }

    const handleEmptySearchInActive = (e) => {
        setSearchValueInActive(e.target.value);
    }


    const handleSearchActive = async () => {
        if (searchValueActive !== null) {
            setCurrPageActive(1);
            setActiveList(await searchArray("C", getApiUrlActive(), searchKeys, searchValueActive.trim()));
        }
    }

    const handleSearchInActive = async () => {
        if (searchValueInActive !== null) {
            setCurrPageInActive(1);
            setInActiveList(await searchArray("C", getApiUrlInActive(), searchKeys, searchValueInActive.trim()));
        }
    }


    useEffect(() => {
        setTotalPagesActive(Math.ceil(activeList.length / itemsPerPageActive));
        const startIndexActive = (currPageActive - 1) * itemsPerPageActive;
        let endIndexPdf = startIndexActive + itemsPerPageActive;

        if (endIndexPdf > activeList.length) {
            endIndexPdf = activeList.length;
        }
        setStartIndexActive(startIndexActive);
        setDisplayedDataActive(activeList.slice(startIndexActive, endIndexPdf));
    }, [activeList, currPageActive, itemsPerPageActive]);

    useEffect(() => {
        setTotalPagesInActive(Math.ceil(inActiveList.length / itemsPerPageInActive));
        const startIndexInActive = (currPageInActive - 1) * itemsPerPageInActive;
        let endIndexReference = startIndexInActive + itemsPerPageInActive;

        if (endIndexReference > inActiveList.length) {
            endIndexReference = inActiveList.length;
        }
        setStartIndexInActive(startIndexInActive);
        setDisplayedDataInActive(inActiveList.slice(startIndexInActive, endIndexReference));
    }, [inActiveList, currPageInActive, itemsPerPageInActive])



    useEffect(() => {
        if (activeSectionNameSort == true || activeSectionNameSort == false) {
            setActiveSectionIdSort(null);
            setActivePrincipleNameSort(null);
        }
    }, [activeSectionNameSort])

    useEffect(() => {
        if (activeSectionIdSort == true || activeSectionIdSort == false) {
            setActiveSectionNameSort(null);
            setActivePrincipleNameSort(null);
        }
    }, [activeSectionIdSort])

    useEffect(() => {
        if (activePrincipleNameSort == true || activePrincipleNameSort == false) {
            setActiveSectionNameSort(null);
            setActiveSectionIdSort(null);
        }
    }, [activePrincipleNameSort])



    useEffect(() => {
        if (inActiveSectionNameSort == true || inActiveSectionNameSort == false) {
            setInActiveSectionIdSort(null);
            setInActivePrincipleNameSort(null);
        }
    }, [inActiveSectionNameSort])

    useEffect(() => {
        if (inActiveSectionIdSort == true || inActiveSectionIdSort == false) {
            setInActiveSectionNameSort(null);
            setInActivePrincipleNameSort(null);
        }
    }, [inActiveSectionIdSort])

    useEffect(() => {
        if (inActivePrincipleNameSort == true || inActivePrincipleNameSort == false) {
            setInActiveSectionNameSort(null);
            setInActiveSectionIdSort(null);
        }
    }, [inActivePrincipleNameSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Section List</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Section List</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="d-grid gap-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <button className={`${activeTab === "active" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("active")} >Active List</button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <button className={`${activeTab === "inactive" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("inactive")} >Inactive List</button>
                                                            </div>
                                                        </div>

                                                        {activeTab == "active" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueActive}
                                                                        onChange={handleEmptySearchActive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchActive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchActive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Section Name
                                                                                <SortIcon sortState={activeSectionNameSort} setSortState={setActiveSectionNameSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"sectionName"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Section ID
                                                                                <SortIcon sortState={activeSectionIdSort} setSortState={setActiveSectionIdSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"sectionId"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Section Incharge
                                                                                <SortIcon sortState={activePrincipleNameSort} setSortState={setActivePrincipleNameSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"sectionInchargeName"} />
                                                                            </th>
                                                                            <th scope="col">Email</th>
                                                                            <th scope='col'>Contact No</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataActive?.length > 0 ?
                                                                                displayedDataActive?.map((section, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndexActive + index + 1}</th>
                                                                                            <td>{section.sectionName}</td>
                                                                                            <td>{section.sectionId}</td>
                                                                                            <td>{section.sectionInchargeName}</td>
                                                                                            <td>{section.email}</td>
                                                                                            <td>{section.contactNumber}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Section Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageActive} setCurrPage={setCurrPageActive} totalPages={totalPagesActive} itemsPerPage={itemsPerPageActive} setItemsPerPage={setItemsPerPageActive} totalItem={activeList.length} />
                                                            </div>}

                                                        {activeTab == "inactive" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueInActive}
                                                                        onChange={handleEmptySearchInActive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchInActive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchInActive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Section Name
                                                                                <SortIcon sortState={inActiveSectionNameSort} setSortState={setInActiveSectionNameSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"sectionName"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Section ID
                                                                                <SortIcon sortState={inActiveSectionIdSort} setSortState={setInActiveSectionIdSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"sectionId"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Section Incharge
                                                                                <SortIcon sortState={inActivePrincipleNameSort} setSortState={setInActivePrincipleNameSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"sectionInchargeName"} />
                                                                            </th>
                                                                            <th scope="col">Email</th>
                                                                            <th scope='col'>Contact No</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataInActive?.length > 0 ?
                                                                                displayedDataInActive?.map((section, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndexInActive + index + 1}</th>
                                                                                            <td>{section.sectionName}</td>
                                                                                            <td>{section.sectionId}</td>
                                                                                            <td>{section.sectionInchargeName}</td>
                                                                                            <td>{section.email}</td>
                                                                                            <td>{section.contactNumber}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Section Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageInActive} setCurrPage={setCurrPageInActive} totalPages={totalPagesInActive} itemsPerPage={itemsPerPageInActive} setItemsPerPage={setItemsPerPageInActive} totalItem={inActiveList.length} />
                                                            </div>}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
};

export default InstituteDashboardSectionList;